import { FC } from "react";

import { ConfirmActionModal } from "src/components/Modal";
import { useToast } from "src/components/Toasts/ToastContainer";
import { mapToModalError } from "src/errors";
import { useReopenAlertMutation } from "src/graphql/anti-fraud/queries/alerts/mutations/ReopenAlertMutation";
import { useT } from "src/internationalization";
import { Alert } from "src/types/alert.ts";

export type ReopenAlertModalProps = {
  alert: Alert;
  onClose: () => void;
};

export const ReopenAlertModal: FC<ReopenAlertModalProps> = ({ alert, onClose }) => {
  const t = useT();
  const { showSuccessToast } = useToast();

  const {
    performMutation: reopenAlert,
    error,
    loading,
  } = useReopenAlertMutation({
    onSuccess: () => {
      showSuccessToast(t("reopen.alert.success.message"));
      onClose();
    },
  });

  return (
    <ConfirmActionModal
      title={t("reopen.alert.modal.title")}
      loading={loading}
      onConfirm={() => reopenAlert({ id: alert.id })}
      onClose={onClose}
      size="sm"
      error={mapToModalError(error)}
      confirmButtonText={t("reopen.alert.modal.confirm.button")}
    >
      <p>{t("reopen.alert.modal.message")}</p>
    </ConfirmActionModal>
  );
};
